// src/pages/Unauthorized.tsx
import React from "react";
import { Link } from "react-router-dom";

export default function Unauthorized() {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        fontFamily: "sans-serif",
        textAlign: "center",
        padding: "1rem",
      }}
    >
      <h1 style={{ fontSize: "4rem", margin: 0 }}>401</h1>
      <p style={{ fontSize: "1.5rem" }}>Unauthorized – you need to sign in.</p>
      <Link to="/signin" style={{ color: "#007bff", textDecoration: "none" }}>
        Go to Sign-in
      </Link>
    </div>
  );
}